import React, { useMemo } from 'react';
import { calcularTVP } from './utils';

const COLORES_RANK = ['#450a0a', '#7f1d1d', '#991b1b', '#b91c1c', '#dc2626'];

const ItemRanking = ({ item, index, tipo }) => {
    const velColor = item.velocidadMax >= 100 ? '#ef4444' : '#f97316';
    return (
        <div className="ev-rank-item">
            <span className="ev-rank-badge" style={{ background: COLORES_RANK[index] ?? '#6b7280' }}>
                {index + 1}
            </span>
            <span className="ev-rank-nombre">{item.nombre}</span>
            <div className="ev-rank-stats">
                <span className="ev-rank-stat">
                    <i className="pi pi-list" />{item.total}
                </span>
                <span className="ev-rank-stat" style={{ color: velColor, fontWeight: 700 }}>
                    <i className="pi pi-bolt" />{item.velocidadMax} km/h
                </span>
                <span className="ev-rank-stat">
                    <i className="pi pi-gauge" />{item.promedio} km/h
                </span>
            </div>
        </div>
    );
};

const GestionRiesgo = ({ datos }) => {
    const topUnidades = useMemo(() => calcularTVP(datos, 'ID_UNIDAD').slice(0, 5), [datos]);
    const topOperadores = useMemo(() => calcularTVP(datos, 'OPERADOR').slice(0, 5), [datos]);
  

    return (
        <section className="ev-seccion">
            <h3 className="ev-seccion-titulo">
                <i className="pi pi-shield" /> GESTIÓN DE RIESGO — TVP
            </h3>
            <div className="ev-riesgo-grid">
                <div className="ev-riesgo-bloque">
                    <h4 className="ev-sub-titulo">Top 5 Operadores</h4>
                    <div className="ev-rank-lista">
                        {topOperadores.map((item, i) => (
                            <ItemRanking key={item.nombre} item={item} index={i} />
                        ))}
                    </div>
                </div>
                <div className="ev-riesgo-bloque">
                    <h4 className="ev-sub-titulo">Top 5 Unidades</h4>
                    <div className="ev-rank-lista">
                        {topUnidades.map((item, i) => (
                            <ItemRanking key={item.nombre} item={item} index={i} />
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default GestionRiesgo;
